class Timer {
  timer: ReturnType<typeof setTimeout> | null

  constructor() {
    this.timer = null
  }

  debounce(func: (...args: any[]) => void, time: number) {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    this.timer = setTimeout(func, time)
  }
}

export default Timer
